// @ts-strict-ignore
import type { MutationHookOptions } from "@apollo/client";
import { useMutation, gql } from "@apollo/client";

const StoreProfitMarginUpdate_Shared_Mutation = gql`
  mutation StoreProfitMarginUpdate_Shared_Mutation($input: StoreProfitMarginUpdateInput!) {
    storeProfitMarginUpdate(input: $input) {
      store {
        id
        discount
        profitMargin
      }
      errors {
        message
        fields {
          profitMargin
        }
      }
    }
  }
`;

interface StoreProfitMarginUpdateData {
  store: { id: string; discount: number; profitMargin };
  errors: { message };
}

interface Variables {
  input: {
    attributes: {
      profitMargin: number;
    };
  };
}

const useStoreProfitMarginUpdateMutation = (
  options?: MutationHookOptions<StoreProfitMarginUpdateData, Variables>
) =>
  useMutation<StoreProfitMarginUpdateData, Variables>(
    StoreProfitMarginUpdate_Shared_Mutation,
    options
  );

export type { StoreProfitMarginUpdateData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useStoreProfitMarginUpdateMutation, StoreProfitMarginUpdate_Shared_Mutation };
